import React from "react";
import "./EmailClassifyBusyOverlay.css";

function EmailClassifyBusyOverlay({ label, completed, total, variant = "modal" }) {
  const determinate = Number(total) > 0;
  const pct = determinate ? Math.min(100, (Number(completed) / Number(total)) * 100) : 0;
  const wrapClass = variant === "fullscreen" ? "email-delete-fullscreen-overlay" : "email-classify-busy";
  const cardClass = variant === "fullscreen" ? "email-delete-progress-card" : "email-classify-busy-card";

  return (
    <div className={wrapClass} aria-live="polite" aria-busy="true">
      <div className={cardClass}>
        <div className="email-classify-busy-text">{label}</div>
        {determinate && (
          <div className="email-classify-busy-count">
            {completed} / {total}
          </div>
        )}
        <div className="email-classify-busy-bar-wrap" aria-hidden="true">
          {determinate ? (
            <div className="email-classify-busy-bar-fill email-classify-busy-overlay__fill" style={{ "--email-classify-progress": `${pct}%` }} />
          ) : (
            <div className="email-classify-busy-bar" />
          )}
        </div>
      </div>
    </div>
  );
}

export default EmailClassifyBusyOverlay;
